import { TestingInstructionPipelineSchema } from '@terra/shared-schemas-orchestrator';
import type { TestingInstructionPipeline } from './types';

export const APPLICATION_PIPELINES: TestingInstructionPipeline[] = [
  ...TestingInstructionPipelineSchema.options,
];

export const NETWORK_PIPELINES: TestingInstructionPipeline[] = [
  'SIGNAL_GENERATION',
  'ATTACK',
  'DISCOVERY',
  'PROBING',
];

export const ALL_FILTER_VALUE = 'all';

export const TESTING_INSTRUCTION_APPLY_MODE_FILTER_ID =
  'testingInstructionApplyMode';

export const TESTING_INSTRUCTION_PIPELINE_FILTER_ID =
  'testingInstructionPipeline';

export const TESTING_INSTRUCTION_CATEGORY_FILTER_ID =
  'testingInstructionCategory';
